import { recaptchaConstants } from "../constants";

export function validateRecaptcha(data) {
  return { type: recaptchaConstants.VALIDATE_RECAPTCHA, payload: data };
}